import classNames from 'classnames';
import { CustomButton } from 'holistic-resources';
import { GoCheck } from 'react-icons/go';
import { useSelector } from 'react-redux';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function ContactAgentButton({
  label = '',
  className = '',
  isSelected = false,
  onClick,
}) {
  const { theme } = useSelector((state) => state.ui);
  const buttonClass = `${className} relative grow font-medium rounded-lg [@media(hover:hover){&:hover}]:underline [@media(hover:hover){&:hover}]:bg-[${
    isSelected ? theme.brandColour : DEFAULT_PRIMARY_COLOUR
  }]/[0.1]`;
  const unselectedClass = 'border-2 border-secondary text-primary';
  const selectedClass = 'bg-primary text-white';

  const onClickHandler = () => {
    onClick?.();
  };

  return (
    <CustomButton
      onClick={onClickHandler}
      className={classNames(`${buttonClass}`, {
        [unselectedClass]: !isSelected,
        [selectedClass]: isSelected,
      })}
      style={{
        background:
          (isSelected && theme.brandColour) ||
          (isSelected && DEFAULT_PRIMARY_COLOUR),
        borderColor: theme.brandColour,
        color:
          (!isSelected && theme.brandColour) ||
          (!isSelected && DEFAULT_PRIMARY_COLOUR),
      }}
    >
      <div className="px-8 py-4 flex items-center justify-center gap-2">
        {label}{' '}
        {isSelected && (
          <div className="text-2xl">
            <GoCheck />
          </div>
        )}
        {isSelected && (
          <svg
            className="absolute text-primary h-5 w-full left-0 top-full"
            x="0px"
            y="0px"
            viewBox="0 0 255 255"
          >
            <polygon
              fill={theme.brandColour || DEFAULT_PRIMARY_COLOUR}
              points="0,0 127.5,127.5 255,0"
            />
          </svg>
        )}
      </div>
    </CustomButton>
  );
}
